import React from 'react';
import { Reveal } from './Reveal';
const bonusImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/6R1ZYb5D6Q8ENoFfyHLfgK/ChatGPT_Image_28_jul_2026,_10_21_10_a.m..png',
  alt: 'Bonus 01 — Step Class Planner & Calendar, free with your purchase'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/kfgpQQ5JjTxcmfZaunhQYv/ChatGPT_Image_28_jul_2026,_10_39_44_a.m..png',
  alt: 'Bonus 02 — Step Safety & Liability Checklist, free with your purchase'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vtcsVaHyi9cR8cVrDpNmdF/ChatGPT_Image_28_jul_2026,_10_39_36_a.m..png',
  alt: 'Bonus 03 — Step Instructor Power Cues Glossary, free with your purchase'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/jefZds5oNsFq7obhtjqe1X/ChatGPT_Image_28_jul_2026,_01_57_45_p.m..png',
  alt: 'Bonus 04 — The 45° Step Alignment Poster, free with your purchase'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/x7ApWb3wJSiFwnJPLKWCND/ChatGPT_Image_28_jul_2026,_05_41_09_p.m..png',
  alt: 'Bonus 05 — Step Class Social Media Hero Kit, free with your purchase'
}];
export function Bonuses() {
  return <section className="w-full bg-sky px-4 py-20 sm:py-24" data-id="element-19" data-mp="3dfle77z1102h">
      <div className="mx-auto max-w-6xl" data-id="element-20" data-mp="3df3cvwxibvnp">
        <Reveal className="text-center" data-id="element-21" data-mp="3r79qpcd6tqjz">
          <h2 className="font-display text-3xl font-extrabold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-22" data-mp="3r68f96s9f21q">
            🎁 5 Exclusive <span className="text-green-dark" data-id="element-23" data-mp="3n7iu2s0zcg7j">Bonus Resource Kits</span>
          </h2>
          <p className="mt-2 text-sm text-slate" data-id="element-24" data-mp="2zhogg88u6nm8">Included FREE with your purchase</p>
        </Reveal>
        <div className="mt-8 grid gap-5 md:grid-cols-2" data-id="element-25" data-mp="2uik9zpdar3zl">
          {bonusImages.map((image, index) => <Reveal key={image.src} delay={index % 2 * 0.06} className={index === 4 ? 'md:col-span-2 md:mx-auto md:w-[calc(50%-0.625rem)]' : ''} data-id="element-26" data-mp="38hjymx0t7ivr" data-mpi={index}>
              <article className="overflow-hidden rounded-2xl border border-sky-line bg-surface shadow-premium" data-id="element-27" data-mp="npi2m9269qr2">
                <img src={image.src} alt={image.alt} className="block h-auto w-full" data-id="element-28" data-mp="ipwsr3lgrxzk" />
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}